import React from "react";

import { Icon } from "@iconify/react/dist/iconify.js";
import { Tooltip } from "@mui/material";

import { FileData } from "../../../../../util/interfaces/FileData";

interface FileItemProps {
  file: FileData;
  validFiletype: boolean;
  differentFilename: boolean;
}

const StepOneFileItem: React.FC<FileItemProps> = ({ file, validFiletype, differentFilename }) => {
  return (
    <div className="file_list_slide_override" key={file.file.name}>
      <div
        data-testid="fileSection"
        className="file_title_list override_list"
        style={{ display: validFiletype ? "none" : "", color: "black" }}
      >
        <Tooltip title={file ? file.file.name : null} arrow>
          <p
            style={{
              width: "auto",
              maxWidth: "40%",
              fontWeight: differentFilename ? "500" : "400",
            }}
          >
            {file.file.name}
          </p>
        </Tooltip>
        {differentFilename ? (
          <Tooltip
            title={
              "This file's name does not match, uploading will override the current version but keep the original file's name"
            }
            arrow
          >
            <Icon
              icon="ep:warning-filled"
              height={15}
              style={{
                display: validFiletype ? "none" : "",
                color: "black",
                marginLeft: "5px",
              }}
              aria-label={`Warning: ${file.file.name} will override existing file`}
            />
          </Tooltip>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default StepOneFileItem;
